import React from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import ObligationsValues from './ObligationsValues';
const log = new Logger('MAKING_TAX_DIGITAL_PAGE', LOG_LEVELS.DEBUG);
class ObligationsPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pages: -1,
            loading: true,
            pageSize: 1000,
            count: 0,
            page: 1,
        };
    }
    UNSAFE_componentWillMount() {
        log.debug('componentWillMount()');
        log.clearDictionaryError(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH);
    }

    render() {
        log.debug('render(): ', this.props);
        return (
            <div>
                <ObligationsValues
                    data={this.props.obligationsData}
                    pageSizeOptions={[1000, 2000, 5000, 10000]}
                    defaultPageSize={this.state.pageSize}
                    vatNumber={this.props.filterCriteria.vatnumber}
                    companyCode={this.props.filterCriteria.companyCode}
                />
             <div className="clear"></div>
            </div>
        );
    }
}

ObligationsPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
};
// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps', state);
    return {
        languages: state.languages,
        obligationsData: (state.ukMTDVAT && state.ukMTDVAT.obligations) || [],
        companies: (state.companies && state.companies.data ) || []
    };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ObligationsPage);